<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 19L5.71723 15.7474C5.89952 15.5879 6.13351 15.5 6.37574 15.5H10H13.6243C13.8665 15.5 14.1005 15.5879 14.2828 15.7474L18 19M14 9C14 11.2091 12.2091 13 10 13C7.79086 13 6 11.2091 6 9C6 6.79086 7.79086 5 10 5C12.2091 5 14 6.79086 14 9Z" stroke="#000" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M19 8L19 14M22 11L16 11" stroke="#000"/>
</svg>
